/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

const PROVIDERS = {
  apns: {
    icon: new URL('cio/assets/images/push-providers/apns.png', import.meta.url).toString(),
    title: 'Apple Push Notification Service',
  },
  fcm: {
    icon: new URL('cio/assets/images/push-providers/fcm.png', import.meta.url).toString(),
    title: 'Firebase Cloud Messaging',
  },
};

interface ProviderButtonArgs {
  provider: 'apns' | 'fcm';
}

export default class ProviderButton extends Component<ProviderButtonArgs> {
  get provider() {
    return PROVIDERS[this.args.provider];
  }
}
